/** Скільки нещодавно відкритих модулів пам'ятати для робочого простору (прототип v4: recent[ws], до 6). */
export const RECENT_MODULES_MAX = 6;

/** Новий список нещодавніх модулів: відкритий модуль — першим, без повторів, не довше `max`. Чиста функція. */
export function pushRecent(list: readonly string[], key: string, max = RECENT_MODULES_MAX): string[] {
  return [key, ...list.filter((k) => k !== key)].slice(0, max);
}
